// import { siteConfig } from '@/configs/siteConfig';

//
// ${n} px以上の変化があるかどうかをチェック
//
export const isOverNDiff = (a: number, b: number, n = 1): boolean => Math.abs(a - b) > n;

//
// 指定のdata属性の値が空のものをすべて取得
//
export const getElsDataAttrBlank = (dataAttr: string) => {
  return Array.from(document.querySelectorAll(`[data-${dataAttr}]`))
    .filter((el): el is HTMLElement => el instanceof HTMLElement)
    .filter((el) => {
      const val = el.getAttribute(`data-${dataAttr}`);
      return val === '' || val === null;
    });
};

//
// 指定のタグで文字を囲む関数を返す関数
//
export const getFnWrapWithTag = (tagName: string) => {
  return (char: string): HTMLElement => {
    const el = document.createElement(tagName);
    el.textContent = char;
    return el;
  };
};
